// http://vanslaars.io/post/motorcycle-declarative-form-input/
// http://vanslaars.io/post/motorcycle-lessons-follow-up/

import {div, label, input, hr, h4, button, p} from '@motorcycle/dom';

import isolate from '@cycle/isolate'

function intent(sources){
  const input$ = sources.DOM.select('.field').events('input')
  const click$ = sources.DOM.select('.submitbtn').events('click')

  const enter$ = sources.DOM.select('.field').events('keydown')
    .filter(e => e.keyCode === 13)

  const newValue$ = input$
    .map(e => ({type:'INPUT', data:e.target.value}))

  const submit$ = input$.sampleWith(click$)
    .merge(enter$)
    .map(e=> ({type:'SUBMIT', data:e.target.value}))
    .multicast()

  return {
    action$: submit$.merge(newValue$),
    submit$: submit$
  }
}

function model(actions$){
  return actions$.scan((state, action)=>{
    console.log("SUB",state,"AC",action)
    switch(action.type){
      case 'INPUT':
        return action.data
      case 'SUBMIT':
        return ''
      default:
        return state
    }
  }, '' )
}

function view(state$){
  return state$.map(state=>{
    return div('.child',[
      label('Name:'),
      input('.field', {attrs: {type: 'text'}, props:{value: state}}),
      button('.submitbtn',{attrs:{type:'submit',value:'Save', disabled: !state}},'Submit')
    ])
  })
}

export default isolate((sources)=>{
  const intents = intent(sources)
  const state$ = model(intents.action$)
  const vtree$ = view(state$)
  return {
    DOM: vtree$,
    submit$: intents.submit$.map(a => console.log("PASSING ON",a) || a.data)
  }
});


/** WEBPACK FOOTER **
 ** ./components/submit_enter_naked.js
 **/